import React from "react";

const winners = [
  { sno: "1", category: "Exploration Company of the Year", winner: "Oil and Natural Gas Corporation Limited" },
  { sno: "2a", category: "Oil & Gas Production Company of the Year (≥1 MTOE)", winner: "Oil India Limited" },
  { sno: "2b", category: "Oil & Gas Production Company of the Year (<1 MTOE)", winner: "Sun Petrochemicals Private Limited" },
  { sno: "3", category: "Best Managed Project of the Year", winner: "Shell Companies in India" },
  { sno: "4", category: "City Gas Distribution Company of the Year", winner: "Indraprastha Gas Limited" },
  { sno: "5", category: "Pipeline Transportation Company of the Year", winner: "Bharat Petroleum Corporation Limited" },
  { sno: "6", category: "Refinery of the Year", winner: "Reliance Industries Limited — SEZ Jamnagar Refinery" },
  {
    sno: "7",
    category: "Innovator of the Year (Team)",
    winner: (
      <>
        <strong>Joint Winner:</strong>
        <br />
        Indian Oil Corporation Limited – IVIZOMaxCAT (Indigenous Light Naphtha Isomerization Technology)
        <br />
        <br />
        Mangalore Refinery & Petrochemicals Limited – Deodorizing Unit (DeoU)
      </>
    ),
  },
  { sno: "8a", category: "Young Achiever of the Year (Female)", winner: "Vanashree Mhatre, Pipeline Infrastructure Limited" },
  { sno: "8b", category: "Young Achiever of the Year (Male)", winner: "Karthick R, Mangalore Refinery & Petrochemicals Limited" },
  { sno: "9", category: "Oil Marketing Company of the Year", winner: "Hindustan Petroleum Corporation Limited" },
];

const WinnerTable = () => {
  return (
    <div className="sidebar-content">
      <div className="content-box" style={{ padding: "20px" }}>
        <h2 style={{ marginBottom: "6px" }}>Winners of FIPI Awards 2024-25</h2>
        {/* <p style={{ fontSize: "13px", color: "#888", marginBottom: "20px" }}>
          Ceremony held on 26 November 2024
        </p> */}

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              tableLayout: "fixed",
            }}
          >
            <colgroup>
              <col style={{ width: "60px" }} />
              <col style={{ width: "40%" }} />
              <col style={{ width: "auto" }} />
            </colgroup>
            <thead>
              <tr style={{ backgroundColor: "#f5f5f5" }}>
                <th
                  style={{
                    padding: "12px 14px",
                    textAlign: "left",
                    fontWeight: "600",
                    fontSize: "12px",
                    color: "#555",
                    borderBottom: "2px solid #ddd",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  S.No.
                </th>
                <th
                  style={{
                    padding: "12px 14px",
                    textAlign: "left",
                    fontWeight: "600",
                    fontSize: "12px",
                    color: "#555",
                    borderBottom: "2px solid #ddd",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Award Category
                </th>
                <th
                  style={{
                    padding: "12px 14px",
                    textAlign: "left",
                    fontWeight: "600",
                    fontSize: "12px",
                    color: "#555",
                    borderBottom: "2px solid #ddd",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Winner
                </th>
              </tr>
            </thead>
            <tbody>
              {winners.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#fafafa",
                    transition: "background-color 0.15s",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#eef4ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      index % 2 === 0 ? "#ffffff" : "#fafafa")
                  }
                >
                  <td
                    style={{
                      padding: "12px 14px",
                      borderBottom: "1px solid #eee",
                      color: "#888",
                      fontWeight: "500",
                      fontSize: "13px",
                    }}
                  >
                    {row.sno}
                  </td>
                  <td
                    style={{
                      padding: "12px 14px",
                      borderBottom: "1px solid #eee",
                      color: "#333",
                      lineHeight: "1.5",
                    }}
                  >
                    {row.category}
                  </td>
                  <td
                    style={{
                      padding: "12px 14px",
                      borderBottom: "1px solid #eee",
                      color: "#222",
                      lineHeight: "1.6",
                      fontWeight: "500",
                    }}
                  >
                    {row.winner}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WinnerTable;